import * as React from "react";
import { styled } from "@mui/system";
import MUICardActionArea from "@mui/material/CardActionArea";
// import { CardActionAreaProps as CardActionAreaPropsMUI } from "@mui/material/CardActionArea";
import {
  CardActionAreaTypeMap,
  CardActionAreaProps as CardActionAreaPropsMUI
} from "@mui/material/CardActionArea";
import { ButtonBaseTypeMap } from "@mui/material/ButtonBase";
import { OverridableComponent } from "@mui/types";
export interface CardActionAreaProps extends CardActionAreaPropsMUI {}

export const CardActionArea: OverridableComponent<
  CardActionAreaTypeMap<{}, ButtonBaseTypeMap["defaultComponent"]>
> = MUICardActionArea;
